import { usePageTitle } from '@btime/react-hooks'
import React from 'react'

import TemplateRecordPdfPrintButton from '../../../../containers/templateRecords/TemplateRecordPdfPrintButton'
import { usePermalinkNavigation } from '../../../../utils/routes/permalinkNavigation'
import PageHeaderPanel from '../../../../components/presentation/PageHeaderPanel'
import { useServiceOrder } from '../_load/ServiceOrderLoader'

const PageHeader = ({ templateId }) => {
  const serviceOrder = useServiceOrder()
  const navigate = usePermalinkNavigation()
  const title = `Relatório de não conformidades`
  usePageTitle(title)

  return (
    <PageHeaderPanel
      leftIcon="BsArrowLeftShort"
      leftAction={() => navigate(`/service-orders/${serviceOrder.id}/resume`)}
      title={title}
      mediumPadding
      noContainer
      side={<TemplateRecordPdfPrintButton name={title} recordId={serviceOrder?.id} templateId={templateId} />}
    />
  )
}

export default PageHeader
